module.exports = __webpack_public_path__ + "img/My Assets.9c4ca17b.jpeg";